import DayGridScenario from './schema/DayGridScenario';
import DayGridStore from './schema/DayGridStore';
import { ObservableMap } from 'mobx';
import { SchedulingGridViewStateHost } from 'owa-calendar-scheduling-grid';
import { createStore } from 'satcheljs';

const getStore = createStore<DayGridStore>('dayGridStore', {
    scenarios: new ObservableMap<DayGridScenario, SchedulingGridViewStateHost>(),
});
export default getStore;
